/**
 * WordPress dependencies
 */
import '@wordpress/core-data';

export { store } from './store';
export * from './components';
